/**
 * Session helpers for the create-memorial wizard payment gate.
 * Paid plan selection must NOT unlock Privacy/Theme until Success confirms payment (or Free).
 */

export const emptyMemorialForm = (seed = {}) => ({
  firstName: seed.firstName || "",
  lastName: seed.lastName || "",
  gender: "",
  relationship: "",
  country: "",
  birthDate: null,
  birthPlace: "",
  passedDate: null,
  deathPlace: "",
  deathCountry: "",
  webAddress: "",
  publicVisibility: false,
  selectedPlan: "",
});

export const clearMemorialPaymentSession = () => {
  localStorage.removeItem("package");
  localStorage.removeItem("pendingPackage");
  sessionStorage.removeItem("package");
  sessionStorage.removeItem("memorialWizardAfterPayment");
};

/** Drop loved-one draft from session (React state must be reset via context). */
export const clearMemorialFormSession = () => {
  sessionStorage.removeItem("formData");
  sessionStorage.removeItem("memorialID");
};

/** Remember intended paid plan while Stripe Checkout is open (does not unlock wizard). */
export const beginPaidCheckout = (planName) => {
  localStorage.setItem("pendingPackage", String(planName));
  localStorage.removeItem("package");
  sessionStorage.removeItem("memorialWizardAfterPayment");
};

/** After Free selection or paid Success — unlock Privacy → Theme for this wizard only. */
export const confirmPlanForWizard = (planName) => {
  const plan = planName === null || planName === undefined ? "" : String(planName);
  if (plan !== "") {
    localStorage.setItem("package", plan);
  }
  localStorage.removeItem("pendingPackage");
  sessionStorage.setItem("memorialWizardAfterPayment", "1");
};

export const isWizardPlanConfirmed = () => {
  const flag = sessionStorage.getItem("memorialWizardAfterPayment") === "1";
  const pkg = localStorage.getItem("package");
  return flag && pkg !== null && pkg !== "";
};

export const getConfirmedPackage = () => {
  if (!isWizardPlanConfirmed()) return null;
  const raw = localStorage.getItem("package");
  const n = parseInt(raw, 10);
  return Number.isNaN(n) ? null : n;
};

/**
 * Abandon / start over: clear payment + form session keys.
 * Call from Cancel or before a brand-new create; React state reset lives in MemorialContext.
 */
export const startFreshMemorialWizard = () => {
  clearMemorialPaymentSession();
  clearMemorialFormSession();
};
